import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { StoreToggle } from '@printdeal/feature-management/react';
// @ts-expect-error
import { selectors as customerSelectors } from '../../../../store/slices/customerSlice';

// Helpers & Hooks
import useSystemPages from '../../../../hooks/useSystemPages';
import { dispatchDataLayerEventOnQuoteViewAll } from '../../../../helpers/dataLayerHelpers/quoteDataLayerHelper';
import { reOrderMessages } from '../../../re-order/helpers/reOrderHelper';

// Components
import AccountLink from './AccountLink';
import { getConfiguration } from '../../../../helpers/Configuration';
import CustomerProgramAccountLink from '../../../customer-programs/CustomerProgramAccountLink';

const AccountLinks = () => {
  // Retrieve the relevant system pages
  const [accountDashboardPage] = useSystemPages('accountDashboard');

  // Retrieve the relevant customer data
  const isCompany: boolean = useSelector(customerSelectors.isCustomerCompany);
  const configuration = getConfiguration();

  // Put the menu together
  return (
    <ul data-cy="accountDashboardItems" className="pd-my-4 pd-rounded-md pd-border pd-px-5 pd-py-4">
      <AccountLink
        to={`${accountDashboardPage.path}/orders`}
        title={<FormattedMessage id="header.account.orders.short" defaultMessage="Orders" />}
        text="orders"
        icon="orders"
      />
      <AccountLink
        to={`${accountDashboardPage.path}/../reorder`}
        title={(
          <FormattedMessage
            id={reOrderMessages.reorderNavigationLinkText.id}
            defaultMessage={reOrderMessages.reorderNavigationLinkText.defaultMessage}
          />
        )}
        text="reorder"
        icon="repeat"
      />
      <AccountLink
        to={`${accountDashboardPage.path}/editmain`}
        title={<FormattedMessage id="header.account.settings.short" defaultMessage="Settings" />}
        text="settings"
        icon="user"
      />
      <AccountLink
        to={`${accountDashboardPage.path}/addresses`}
        title={<FormattedMessage id="header.account.addresses.short" defaultMessage="Addresses" />}
        text="addresses"
        icon="address-book"
      />
      <AccountLink
        to={`${accountDashboardPage.path}/invoices`}
        title={<FormattedMessage id="header.account.invoices.short" defaultMessage="Invoices" />}
        text="invoices"
        icon="euro-sign"
      />
      <CustomerProgramAccountLink />
      <AccountLink
        to={`${accountDashboardPage.path}/newsletter`}
        title={<FormattedMessage id="header.account.newsletter.short" defaultMessage="Newsletter" />}
        text="newsletter"
        icon="envelope"
      />
      <AccountLink
        to={`${accountDashboardPage.path}/complaints`}
        title={<FormattedMessage id="header.account.complaints.short" defaultMessage="Complaints" />}
        text="complaints"
        icon="complaints"
      />
      {configuration?.quote?.enabled && (
      <AccountLink
        to={`${accountDashboardPage.path}/quoting`}
        title={<FormattedMessage id="header.account.quoting.short" defaultMessage="Quotes" />}
        text="quoting"
        icon="file"
        onClickEvent={dispatchDataLayerEventOnQuoteViewAll}
      />
      )}
      <AccountLink
        to={`${accountDashboardPage.path}/designs`}
        title={<FormattedMessage id="header.account.designs.short" defaultMessage="Designs" />}
        text="designs"
        icon="image"
      />
      <StoreToggle id="drukwerkdeal-nl">
        <StoreToggle.Enabled>
          {
            isCompany && (
              <AccountLink
                to={`${accountDashboardPage.path}/mandates`}
                title={<FormattedMessage id="header.account.mandates.short" defaultMessage="Mandates" />}
                text="mandates"
                icon="euro-sign"
              />
            )
          }
        </StoreToggle.Enabled>
      </StoreToggle>
    </ul>
  );
};

export default AccountLinks;
